import { render } from "./ViewOrders.vue?vue&type=template&id=7dc04eba"
import script from "./ViewOrders.vue?vue&type=script&lang=js"
export * from "./ViewOrders.vue?vue&type=script&lang=js"

import "./ViewOrders.vue?vue&type=style&index=0&id=7dc04eba&lang=css"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__